import type { I18nKey } from 'types/i18n'

import {
    ROUTE_ACTIVACION_ACTIVO_FIJO,
    ROUTE_APROBAR_TRANSFERENCIA,
    ROUTE_CONFIGURAR_ITEM_ACTIVO_FIJO,
    ROUTE_CONFIGURAR_NIVEL_APROBACION_SOLICITUD_TRANSFERENCIA,
    ROUTE_CONFIGURAR_TIPO_ACTIVO_FIJO,
    ROUTE_CREAR_ACTIVO_FIJO,
    ROUTE_GESTION_ACTIVOS_FIJOS,
    ROUTE_GESTION_AVALUOS,
    ROUTE_GESTION_PLANTILLA_ACTIVO_FIJO,
    ROUTE_GESTION_SOLICITUDES_TRANSFERENCIA,
    ROUTE_INFORME_ACTIVO_FIJO_CON_ALTA_CONTABLE,
    ROUTE_INFORME_ACTIVO_FIJO_SIN_ALTA_CONTABLE,
    ROUTE_INFORME_ACTIVO_FIJO_X_TIPO,
    ROUTE_INFORME_AVALUOS,
    ROUTE_INFORME_DEPRECIACION_ACTIVOS_FIJOS,
    ROUTE_LIQUIDACION_ACTIVO_FIJO,
    ROUTE_PERMISOS_TIPOS_ACTIVOS_FIJOS,
    ROUTE_PLANTILLA_ACTIVO_FIJO,
    ROUTE_REGISTRO_AVALUOS,
    ROUTE_SOLICITAR_TRANSFERENCIA,
} from './names'
import { buildBreadcrumb } from '@/@core/utils/router'
import permission, { RESOURCE_ACTIVO_FIJO_PG } from '@/auth/permissions/modules/activoFijoPg'
import { defineRoutes } from '@/utils/router'

const { configuracion, transacciones, mantenimiento, informes } = permission

//#region helpers
const breadcrumbConfiguracion = (option: I18nKey) =>
    buildBreadcrumb('a:activo_fijo_pg.menu_title', 'a:global.menu.configuracion', option)
const breadcrumbTransaccion = (option: I18nKey) =>
    buildBreadcrumb('a:activo_fijo_pg.menu_title', 'a:global.menu.transacciones', option)
const breadcrumbMantenimiento = (option: I18nKey) =>
    buildBreadcrumb('a:activo_fijo_pg.menu_title', 'a:global.menu.mantenimiento', option)
const breadcrumbInformes = (option: I18nKey) =>
    buildBreadcrumb('a:activo_fijo_pg.menu_title', 'a:global.menu.informes', option)
//#endregion

export default defineRoutes([
    //#region Mantenimiento
    {
        path: '/activo-fijo-pg/mantenimiento/tipos-activos-fijos',
        name: ROUTE_CONFIGURAR_TIPO_ACTIVO_FIJO,
        component: () => import('@/views/pages/activo-fijo-pg/mantenimiento/TiposActivoFijo.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.tipos_activos_fijos',
            action: mantenimiento.tipoActivoFijo,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbMantenimiento('activo_fijo_pg.subopciones.tipos_activos_fijos'),
        },
    },
    {
        path: '/activo-fijo-pg/mantenimiento/gestion-plantillas-activo-fijo',
        name: ROUTE_GESTION_PLANTILLA_ACTIVO_FIJO,
        component: () =>
            import('@/views/pages/activo-fijo-pg/mantenimiento/plantilla-activo-fijo/GestionPlantillaActivoFijo.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.gestion_plantilla_activo_fijo',
            action: mantenimiento.gestionPlantillaActivoFijo,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbMantenimiento('activo_fijo_pg.subopciones.gestion_plantilla_activo_fijo'),
        },
    },
    {
        path: '/activo-fijo-pg/mantenimiento/plantilla-activo-fijo/:idPlantilla?',
        name: ROUTE_PLANTILLA_ACTIVO_FIJO,
        component: () =>
            import('@/views/pages/activo-fijo-pg/mantenimiento/plantilla-activo-fijo/PlantillaActivoFijo.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.plantilla_activo_fijo',
            action: mantenimiento.plantillaActivoFijo,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbMantenimiento('activo_fijo_pg.subopciones.plantilla_activo_fijo'),
        },
    },
    {
        path: '/activo-fijo-pg/mantenimiento/item-activo-fijo',
        name: ROUTE_CONFIGURAR_ITEM_ACTIVO_FIJO,
        component: () => import('@/views/pages/activo-fijo-pg/mantenimiento/GestionItemActivoFijo.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.item_activo_fijo',
            action: mantenimiento.itemActivoFijo,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbMantenimiento('activo_fijo_pg.subopciones.item_activo_fijo'),
        },
    },
    //#endregion

    //#region Configuraciones
    {
        path: '/activo-fijo-pg/configuracion/niveles-aprobacion-solicitud-transferencia',
        name: ROUTE_CONFIGURAR_NIVEL_APROBACION_SOLICITUD_TRANSFERENCIA,
        component: () => import('@pages/activo-fijo-pg/configuracion/NivelAprobacionSolicitudTransferencia.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.nivel_aprobacion_solicitud_transferencia',
            action: configuracion.nivelAprobacionSolicitudTransferencia,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbConfiguracion('activo_fijo_pg.subopciones.nivel_aprobacion_solicitud_transferencia'),
        },
    },
    {
        path: '/activo-fijo-pg/configuracion/permisos/tipos-activos-fijos',
        name: ROUTE_PERMISOS_TIPOS_ACTIVOS_FIJOS,
        component: () => import('@pages/activo-fijo-pg/configuracion/PermisosTiposActivosFijos.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.permisos_tipos_activos_fijos',
            action: configuracion.permisosTiposActivoFijo,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbConfiguracion('activo_fijo_pg.subopciones.permisos_tipos_activos_fijos'),
        },
    },
    //#endregion

    //#region Transacciones
    {
        path: '/activo-fijo-pg/transacciones/activo-fijo/:codigoActivoFijo?',
        name: ROUTE_CREAR_ACTIVO_FIJO,
        component: () => import('@pages/activo-fijo-pg/transacciones/crear-activo-fijo/CrearActivoFijo.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.crear_activo_fijo',
            action: transacciones.crearActivoFijo,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbTransaccion('activo_fijo_pg.subopciones.crear_activo_fijo'),
        },
    },
    {
        path: '/activo-fijo-pg/transacciones/activacion-activo-fijo',
        name: ROUTE_ACTIVACION_ACTIVO_FIJO,
        component: () => import('@pages/activo-fijo-pg/transacciones/ActivacionActivoFijo.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.activacion_activo_fijo',
            action: transacciones.activacionActivoFijo,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbTransaccion('activo_fijo_pg.subopciones.activacion_activo_fijo'),
        },
    },
    {
        path: '/activo-fijo-pg/transacciones/registro-avaluo/:codigoAvaluo?',
        name: ROUTE_REGISTRO_AVALUOS,
        component: () => import('@pages/activo-fijo-pg/transacciones/RegistroAvaluo.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.registro_avaluos',
            action: transacciones.registroAvaluo,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbTransaccion('activo_fijo_pg.subopciones.registro_avaluos'),
        },
    },
    {
        path: '/activo-fijo-pg/transacciones/liquidacion-activo-fijo',
        name: ROUTE_LIQUIDACION_ACTIVO_FIJO,
        component: () => import('@pages/activo-fijo-pg/transacciones/LiquidacionActivoFijo.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.liquidacion_activo_fijo',
            action: transacciones.liquidacionActivoFijo,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbTransaccion('activo_fijo_pg.subopciones.liquidacion_activo_fijo'),
        },
    },
    {
        path: '/activo-fijo-pg/transacciones/gestion/activos-fijos',
        name: ROUTE_GESTION_ACTIVOS_FIJOS,
        component: () => import('@pages/activo-fijo-pg/transacciones/GestionActivoFijo.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.gestion_activo_fijo',
            action: transacciones.gestionActivosFijos,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbTransaccion('activo_fijo_pg.subopciones.gestion_activo_fijo'),
        },
    },
    {
        path: '/activo-fijo-pg/transacciones/gestion/avaluos',
        name: ROUTE_GESTION_AVALUOS,
        component: () => import('@pages/activo-fijo-pg/transacciones/GestionAvaluos.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.gestion_avaluos',
            action: transacciones.gestionAvaluos,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbTransaccion('activo_fijo_pg.subopciones.gestion_avaluos'),
        },
    },
    {
        path: '/activo-fijo-pg/transacciones/solicitar-transferencia',
        name: ROUTE_SOLICITAR_TRANSFERENCIA,
        component: () => import('@pages/activo-fijo-pg/transacciones/SolicitudTransferencia.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.solicitar_transferencia',
            action: transacciones.solicitarTransferencia,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbTransaccion('activo_fijo_pg.subopciones.solicitar_transferencia'),
        },
    },
    {
        path: '/activo-fijo-pg/transacciones/gestion/solicitudes-transferencia',
        name: ROUTE_GESTION_SOLICITUDES_TRANSFERENCIA,
        component: () => import('@pages/activo-fijo-pg/transacciones/GestionSolicitudesTransferencia.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.gestion_solicitudes_transferencia',
            action: transacciones.gestionSolicitudesTransferencia,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbTransaccion('activo_fijo_pg.subopciones.gestion_solicitudes_transferencia'),
        },
    },
    {
        path: '/activo-fijo-pg/transacciones/aprobar-transferencia',
        name: ROUTE_APROBAR_TRANSFERENCIA,
        component: () => import('@pages/activo-fijo-pg/transacciones/AprobacionTransferencia.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.aprobar_transferencia',
            action: transacciones.aprobarTransferencia,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbTransaccion('activo_fijo_pg.subopciones.aprobar_transferencia'),
        },
    },
    //#endregion

    //#region Informes
    {
        path: '/activo-fijo-pg/informes/activo-fijo-x-tipo',
        name: ROUTE_INFORME_ACTIVO_FIJO_X_TIPO,
        component: () => import('@pages/activo-fijo-pg/informes/ActivoFijoXTipo.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.activo_fijo_x_tipo',
            action: informes.activoFijoXTipo,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrum: breadcrumbInformes('activo_fijo_pg.subopciones.activo_fijo_x_tipo'),
        },
    },
    {
        path: '/activo-fijo-pg/informes/activo-fijo-sin-alta-contable',
        name: ROUTE_INFORME_ACTIVO_FIJO_SIN_ALTA_CONTABLE,
        component: () => import('@pages/activo-fijo-pg/informes/ActivoFijoSinAltaContable.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.activo_fijo_sin_alta_contable',
            action: informes.activoFijoSinAltaContable,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbInformes('activo_fijo_pg.subopciones.activo_fijo_sin_alta_contable'),
        },
    },
    {
        path: '/activo-fijo-pg/informes/activo-fijo-con-alta-contable',
        name: ROUTE_INFORME_ACTIVO_FIJO_CON_ALTA_CONTABLE,
        component: () => import('@pages/activo-fijo-pg/informes/ActivoFijoConAltaContable.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.activo_fijo_con_alta_contable',
            action: informes.activoFijoConAltaContable,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbInformes('activo_fijo_pg.subopciones.activo_fijo_con_alta_contable'),
        },
    },
    {
        path: '/activo-fijo-pg/informes/depreciacion-activos-fijos',
        name: ROUTE_INFORME_DEPRECIACION_ACTIVOS_FIJOS,
        component: () => import('@pages/activo-fijo-pg/informes/DepreciacionActivosFijos.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.depreciacion_activos_fijos',
            action: informes.depreciacionActivosFijos,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbInformes('activo_fijo_pg.subopciones.depreciacion_activos_fijos'),
        },
    },
    {
        path: '/activo-fijo-pg/informes/avaluos',
        name: ROUTE_INFORME_AVALUOS,
        component: () => import('@pages/activo-fijo-pg/informes/ReporteDeAvaluos.vue'),
        meta: {
            title: 'i18n:activo_fijo_pg.subopciones.avaluos',
            action: informes.avaluosActivoFijo,
            resource: RESOURCE_ACTIVO_FIJO_PG,
            breadcrumb: breadcrumbInformes('activo_fijo_pg.subopciones.avaluos'),
        },
    },
])
